<ion-header class="modal-header">
  <div class="modal-title">
    <h3>{{ id ? 'Edit Tag' : 'Add Tag' }}</h3>
  </div>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="clear" shape="round" class="close-button" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div style="padding: 16px">
    <ion-label class="input-label"> Name </ion-label>
    <ion-input #nameInput placeholder="e.g. Super users" [(ngModel)]="name" class="input-field"> </ion-input>

    <ion-label class="input-label"> Description </ion-label>
    <ion-textarea
      #descriptionInput
      placeholder="e.g. Customers who heavily use the product"
      [(ngModel)]="description"
      class="input-field"
      rows="8"
    >
    </ion-textarea>

    <div *ngIf="id || showProjectSelector" style="margin-bottom: 16px">
      <ion-label class="input-label">Project</ion-label>
      <ion-input
        readonly
        (click)="selectProject($event)"
        [disabled]="id && !hasLoadedTag"
        [value]="projectName || 'All projects'"
        class="input-field"
      ></ion-input>
    </div>

    <p *ngIf="hasTagLoadFailed" class="subtitle">Tag details failed to load. Retry loading the tag to keep editing.</p>

    <div style="width: 100%; display: flex; align-items: center; justify-content: space-between">
      <ion-label>Tag can be applied automatically by AI?</ion-label>
      <label class="switch" slot="end">
        <input type="checkbox" [(ngModel)]="autoTaggingEnabled" />
        <span class="slider"></span>
      </label>
    </div>
    <p class="subtitle">
      <b>Tip:</b> adding more detailed descriptions will result in more accurate
      <a href="https://docs.unthread.io/docs/unthread-ai/automatically-tagging-conversations-with-ai" target="_blank"
        >AI-automated tags</a
      >
    </p>
  </div>
</ion-content>

<ion-footer class="footer flex-space-between">
  <ion-button (click)="submit()" [disabled]="isLoading || (id && !hasLoadedTag && !hasTagLoadFailed)" class="btn-medium">
    {{ id && hasTagLoadFailed ? 'Retry loading tag' : 'Save tag' }}
    <ion-spinner name="crescent" [hidden]="!isLoading" class="small-spinner margin-left-5"></ion-spinner>
  </ion-button>
  <ion-button color="danger" fill="clear" (click)="delete()" [disabled]="isLoading" *ngIf="id" class="btn-medium">
    <ion-icon name="trash-outline" style="font-size: 18px;"></ion-icon>
  </ion-button>
</ion-footer>
